export default __webpack_public_path__ + "static/media/team-foto3-color.f5b3fd1a.png";